import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {GLOBAL_SANDBOXES_PATHS} from './sandboxesPaths';

export const SANDBOXES_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'Sandboxes',
    },
    exact: true,
    isPrivateRoute: true,
    path: GLOBAL_SANDBOXES_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../components/Sandboxes/SandboxesRouter')
    ).Component,
  },
];
